function getCECaretPosition(element) {
	const sel = window.getSelection();
	let start = 0;
	let end = 0;

	if (!sel.rangeCount) {
		return [start, end];
	}

	const range = sel.getRangeAt(0);
	let charIndex = 0;
	let foundStart = false;
	let foundEnd = false;

	const traverse = (node) => {
		if (node.nodeType === Node.TEXT_NODE) {
			const next = charIndex + node.length;
			if (!foundStart && node === range.startContainer) {
				start = charIndex + range.startOffset;
				foundStart = true;
			}
			if (foundStart && node === range.endContainer) {
				end = charIndex + range.endOffset;
				foundEnd = true;
			}
			charIndex = next;
		} else {
			for (const child of node.childNodes) {
				traverse(child);
				if (foundEnd) break;
			}
		}
	};

	traverse(element);
	return [start, end];
}

function setCECaretPosition(element, position) {
	const range = document.createRange();
	const sel = window.getSelection();
	let charIndex = 0;
	let foundStart = false;
	let foundEnd = false;

	const traverse = (node) => {
		if (node.nodeType === Node.TEXT_NODE) {
			const next = charIndex + node.length;
			if (
				!foundStart &&
				position.start >= charIndex &&
				position.start <= next
			) {
				range.setStart(node, position.start - charIndex);
				foundStart = true;
			}
			if (foundStart && position.end >= charIndex && position.end <= next) {
				range.setEnd(node, position.end - charIndex);
				foundEnd = true;
			}
			charIndex = next;
		} else {
			for (const child of node.childNodes) {
				traverse(child);
				if (foundEnd) break;
			}
		}
	};

	traverse(element);

	if (foundEnd) {
		sel.removeAllRanges();
		sel.addRange(range);
	}
}

function setCaretPositionWithCorrection(element, position) {
	let startCorrection = 0;
	let endCorrection = 0;

	setCECaretPosition(element, position);
	let currentPosition = getCECaretPosition(element);

	// see Bug https://bugs.webkit.org/show_bug.cgi?id=66630
	while (position.start !== currentPosition[0]) {
		position.start -= 1;
		if (position.start < 0) break;
		setCECaretPosition(element, position);
		currentPosition = getCECaretPosition(element);
		startCorrection += 1;
	}

	while (position.end !== currentPosition[1]) {
		position.end += 1;
		setCECaretPosition(element, position);
		currentPosition = getCECaretPosition(element);
		endCorrection += 1;
		if (endCorrection > 10) break; // avoid rare infinite loop
	}

	return [startCorrection, endCorrection];
}

function replaceTextInCE(element, replacement, start, end) {
	const correction = setCaretPositionWithCorrection(element, { start, end });
	const sel = window.getSelection();
	const range = sel.getRangeAt(0);

	if (correction[0] > 0) {
		replacement = sel.toString().substring(0, correction[0]) + replacement;
	}

	const textNode = document.createTextNode(replacement);
	range.deleteContents();
	range.insertNode(textNode);
	range.commonAncestorContainer.normalize();
	start = end = start + replacement.length - correction[0];
	setCaretPositionWithCorrection(element, { start, end });
}

export { getCECaretPosition, replaceTextInCE };
